import has from 'lodash/has';
import { isReadOnly, isAdminAccess } from 'js/lib/ACLUtils';

export const mapStateToProps = (state, ownProps) => {
  const {
    entities: { users },
  } = state;
  const { cardData } = ownProps;
  const readOnly = isReadOnly(cardData);
  const adminAccess = isAdminAccess(cardData);

  const owner = has(cardData, 'owner') && has(users, cardData.owner) ? users[cardData.owner] : null;

  return {
    readOnly,
    adminAccess,
    owner,
  };
};
